

import { Component, Vue, Prop } from "vue-property-decorator"
import { namespace, Getter } from "vuex-class"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { Team } from "@/types"
import { TenantFeatures } from "@/types/tenantFeatures"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class CreateForTeam extends Vue {
	@Prop()
	value!: string[] | null;

	@Prop({ type: Boolean, default: false })
	readonly!: boolean

	@setup.State
	teams!: Team[]

	@setup.Action
	loadTeams!: () => Promise<void>

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	public get bulkCreateEnabled (): boolean {
		return !!this.value
	}

	public set bulkCreateEnabled (value: boolean) {
		if (value) {
			this.$emit("input", this.value ? this.value : [])
		} else {
			this.$emit("input", null)
		}
	}

	public async mounted () {
		if (this.teams.length === 0) {
			await this.loadTeams()
		}

		if (this.value === undefined) {
			this.$emit("input", null)
		}

		if (this.value && this.value.length === 0) {
			// Revert to default on load if nothing selected
			this.bulkCreateEnabled = false
		}
	}

	public valueUpdate (newValue: string[]): void {
		this.$emit("input", newValue)
	}

	private get closeOnSelect ():boolean {
		return !(this.getIsFeatureEnabled(TenantFeatures.MultiSelectKeepOpen))
	}
}

